export default __webpack_public_path__ + "static/media/team4.2bef0e4a.jpg";